import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { AuthenticationService } from '../../shared';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from '../../shared/dialogs/reset-password-dialog/reset-password-dialog.component';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    FlexLayoutModule,
    NgIf,
    MatButton,
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LoginComponent implements OnInit {
  form = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required])
  });
  reason = '';
  error: string;
  isLoading = false;
  tips = [
    'You can jump to the global search by pressing the forward slash key anywhere in the app.',
    'Did you know you have a catalogue site with HireLogic? This enables your ' +
      'customers to browse your products and create a booking request which you can then approve or decline in HireLogic.',
    'You can collect payments and deposits from customers for upcoming bookings when you connect a Stripe account.',
    'You can view all payments received in HireLogic between two dates using the Payments Report',
    'You can automatically sync invoices and payments with multiple accounts packages using our seamless integrations',
    'You can assign workshop and transort jobs to your team members in HireLogic',
    'You can create custom prices for a customer, or even just for a one off hire in HireLogic',
    'You can track the mainetenance of your equipment in HireLogic, and schedule maintenance tasks at set intervals to automate the creation of workshop jobs',
    'You can upload attachments to each piece of equipment in HireLogic, such as manuals, certificates, or photos, then send links to these to your customers'
  ];

  randomTip = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog
  ) {
    this.randomTip = this.tips[Math.floor(Math.random() * this.tips.length)];
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params['reason']) {
        if (params['reason'] === 'timeout') {
          this.reason = 'Logged out due to inactivity.';
        }
      }
    });
  }

  login() {
    this.isLoading = true;
    this.authenticationService.login(this.form.value).subscribe(
      (login) => {
        this.error = null;
        this.form.patchValue({ email: '', password: '' });
        this.isLoading = false;
        if (login.body.user.reset_password) {
          this.dialog.open(ResetPasswordDialogComponent, {
            data: {
              userId: login.body.user.id
            },
            disableClose: true,
            autoFocus: true
          });
        }
        if (this.authenticationService.redirectUrl) {
          this.router.navigateByUrl(this.authenticationService.redirectUrl);
          return;
        }
        this.router.navigate(['dashboard']);
      },
      (error) => {
        this.isLoading = false;
        if (error.status === 401) {
          this.error =
            'Your username or password is incorrect, please try again';
          return;
        }
        this.error =
          'Something went wrong, please try again or contact support if the problem persists.';
      }
    );
  }
}
